import { createI18n } from 'vue-i18n';
import messages from './index.ts';

export const i18n = createI18n({
  globalInstall: true,
  locale: "de",
  messages,
  globalInjection: true,
  legacy: false,
});


export default { i18n };
